/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    CaisModalHeader: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisModalHeader',
        defaultMessage: 'About your payment'
    },
    CaisModalContinue: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisModalContinue',
        defaultMessage: 'Continue'
    },
    CaisErrorAllowedMonthlyMessage: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisErrorAllowedMonthlyMessage',
        defaultMessage: 'We tried to request a credit search but unfortunately we are unable to receive the data. We are still able to offer you the option to pay by monthly instalments.'
    },
    CaisErrorNotAllowedMonthlyMessage: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisErrorNotAllowedMonthlyMessage',
        defaultMessage: 'We tried to request a credit search but unfortunately we are unable to receive the data. We are unable to offer you the option to pay by monthly instalments, however you can still pay for your insurance with a single debit or credit card payment.'
    },
    CaisModalPassedCheckCacheMessage: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisModalPassedCheckCacheMessage',
        defaultMessage: 'A credit check has recently been done by Saga, and based on this information we are able to offer you instalments.'
    },
    CaisModalFailedCheckCacheMessageP1: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisModalFailedCheckCacheMessageP1',
        defaultMessage: 'Based on your previous Experian credit check by Saga, we are sorry to inform you that we are unfortunately unable to offer you instalments at this time.'
    },
    CaisModalFailedCheckCacheMessageP2: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisModalFailedCheckCacheMessageP2',
        defaultMessage: 'If you require more information about Experian\'s services, their contact details are Experian, Customer Help Service, PO Box 8000, Nottingham, NG80 7WF, or call {phoneNumber} or visit '
    },
    CaisModalFailedCheckCacheMessageP2Link: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisModalFailedCheckCacheMessageP2Link',
        defaultMessage: 'www.experian.co.uk'
    },
    CaisModalFailedCheckServiceMessageP1: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisModalFailedCheckServiceMessageP1',
        defaultMessage: 'Sorry, we are unable to offer you the monthly instalments payment option based on the information we have received from Experian. The good news is, you can still '
    },
    CaisModalFailedCheckServiceMessageP1Link: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisModalFailedCheckServiceMessageP1Link',
        defaultMessage: 'pay for your insurance with a single debit or credit card payment.'
    },
    CaisModalFailedCheckServiceMessageP2: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisModalFailedCheckServiceMessageP2',
        defaultMessage: 'If you require more information about Experian\'s services, you can contact them at Experian, Consumer Help Service, PO Box 8000, Nottingham, NG80 7WF, call {phoneNumber} or '
    },
    CaisModalFailedCheckServiceMessageP2Link: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisModalFailedCheckServiceMessageP2Link',
        defaultMessage: 'visit Experian.'
    },
    CaisModalContinueToCardPayment: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisModalContinueToCardPayment',
        defaultMessage: 'Continue to card payment'
    },
    CaisModalBackToQuote: {
        id: 'qnb.spm.declarationsPage.caisModal.CaisModalBackToQuote',
        defaultMessage: 'Take me back to my quote'
    }
});
